export default {
  bind(el, binding) {
    const error = binding.value?.error || '/img/logo/logo-placeholder.svg'
    const baseSrc = binding.value?.baseSrc || '/img/logo/logo-placeholder.svg'
    const nextSrc = binding.value?.nextSrc
    const errorEvent = binding.value?.errorEvent
    const nextLoadEvent = binding.value?.nextLoadEvent

    const throwError = (el, src, event) => {
      el.src = src
      el.classList.add('error')

      if (event) event(el)
    }

    const setNextSrc = (el, src, event) => {
      el.src = src
      el.classList.add('load')

      if (event) event(el)
    }

    if (!el.src) {
      setNextSrc(el, baseSrc)
    }

    const loadHandler = () => {
      if (nextSrc) {
        const tempImage = new Image()
        tempImage.src = nextSrc

        tempImage.onload = () => {
          el.src = nextSrc
          setNextSrc(el, nextSrc, nextLoadEvent)
        }

        tempImage.onerror = () => {
          throwError(el, error, errorEvent)
        }

        el.removeEventListener('load', loadHandler)
      }
    }

    const errorHandler = () => {
      if (error) {
        throwError(el, error, errorEvent)
      }
    }

    const intersectionHandler = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (el.complete) {
            loadHandler()
          }
          else {
            el.addEventListener('load', loadHandler)
          }
          observer.unobserve(el)
        }
      })
    }

    const observer = new IntersectionObserver(intersectionHandler, {
      root: null,
      threshold: 0.1,
    })

    el.__loadHandler__ = loadHandler
    el.__errorHandler__ = errorHandler
    el.__observer__ = observer

    el.addEventListener('error', errorHandler)
    observer.observe(el)
  },
  unbind(el) {
    el.removeEventListener('load', el.__loadHandler__)
    el.removeEventListener('error', el.__errorHandler__)
    if (el.__observer__) {
      el.__observer__.disconnect()
    }
  },
}
